import {StarIcon} from '@common/icons/material/Star';
import clsx from 'clsx';

interface Props {
  score: number | null;
  className?: string;
}
export function TitleRating({score, className}: Props) {
  if (!score) return null;
  return (
    <div
      className={clsx(
        '!flex !items-center gap-x-8 whitespace-nowrap rateText',
        className,
      )}
    >
      <StarIcon className="text-[#f6c700]" />
      <span className="text-base max-md:text-xs font-semibold mt-1">{score} / 10</span>
    </div>
  );
}
